import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';

type Emits = {
  (e: 'input:field', value: string): void;
  (e: 'input', value: Date | null): void;
  (e: 'focus', value: CustomEvent): void;
  (e: 'blur', value: CustomEvent): void;
  (e: 'open', value: CustomEvent): void;
  (e: 'close', value: CustomEvent): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsDateField',
  props: {
  value: {
    type: null as unknown as PropType<string | null>,
    required: true,
  },
  label: {
    type: String,
    required: false,
    default: null,
  },
},
  emits: ["input:field", "input", "focus", "blur", "open", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'input:field', value: string): void;
  (e: 'input', value: Date | null): void;
  (e: 'focus', value: CustomEvent): void;
  (e: 'blur', value: CustomEvent): void;
  (e: 'open', value: CustomEvent): void;
  (e: 'close', value: CustomEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const data = useVModel(props, undefined, emit);

return { __sfc: true,props, emit, data }
}

})